import { SpamScenarioId } from 'owa-junkmail-configuration';
import { createSpamStore } from '../actions/spamListMutatorActions';
import { getMailboxJunkEmailByScenarioId } from 'owa-junkmail-configuration';

export default function discardSpamOption(scenarioId: SpamScenarioId) {
    const spamList = getMailboxJunkEmailByScenarioId(scenarioId);

    // This will 'reconstruct' the spam store with values previously held in user's junk
    // email configuration. Discard by default will throw away store values so we need
    // to ensure user's old configuration persists.
    createSpamStore(scenarioId, spamList.slice());
}
